
import Injection = EECore.Injection;

@Injection.injectableClass("LoginUiBehavior")
export default class UiBehavior {

  removeSectionBasedOnAttribute(container: Element, attribute: string, loginElement: Element, selector: string): void {

    if (!container || !loginElement) return;

    const visible = container.getAttribute(attribute);
    if (!visible) return;

    if (visible.toLowerCase() === "false") {
      const toBeRemoved = (loginElement.querySelector(selector) as HTMLElement);
      if (!toBeRemoved) return;
      toBeRemoved.parentNode.removeChild(toBeRemoved);
    }
  }
}